import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
var selectedOptionInUsersTab = new Array();
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/SiteInfo/SiteInfoList.html'
})

export class SiteInfoListComponent implements OnInit {
    public constants: Constants;
    public siteInfoStatus: any[] = [];
    public serviceType: any[] = [];
    public Search: any = "";
    public Customer_Name: any = "";
    public siteInfo: any[] = [];
    public siteInfoList: any[] = [];
    public customerItem: any[] = [];
    public filterSiteInfoStatus: any = "";
    public filterServiceTypeStatus: any = "";
    public addSiteInfoData: any = {
    addSiteInfoClient: "", addSiteInfoServiceType: "", addSiteInfoOR: "",
    addSiteInfoIsActive: true, Customer_Id: ""
    };
    public editSiteInfoData: any = {};
    public editSiteInfoId: any = 0;
    public packageName: any[] = [];
    public options: any[] = [];
    public subscription: any;
    public isAdd: boolean = true;
    public edithide: boolean = true;
    public addhide: boolean = false;
    active = true;
    public userDetail: any;
    public objSelectedOptions: boolean = true;
    public greater = false;
    public existsServiceName: boolean = false;
    public isFormSubmitted: boolean = false;
    public isDirty: boolean = false;
    public showLoader = false;
    isEditable:boolean=true;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private activatedRoute: ActivatedRoute,
        private _Router: Router) {
        this.subscription =
            this.activatedRoute.queryParams.subscribe(
                (param: any) => {
                    if (param["siteInfo"]) {
                        console.log(JSON.stringify(JSON.parse(param["siteInfo"])));
                        this.editSiteInfoId = (JSON.parse(param["siteInfo"]));
                        this.edithide = false;
                        this.addhide = true;
                        this.objSelectedOptions = true;
                    }
                });
        this.constants = new Constants();
        this.filterSiteInfoStatus = this.constants.enumUserStatus["Active"];
        this.options = [
          //  { name: 'Sys Admin', value: '0', checked: false },
            { name: 'Admin', value: '1', checked: true,disabled:true },
            { name: 'Manager', value: '2', checked: false },
            { name: 'Executive', value: '3', checked: false }];
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
        
        this.getStatus();
        this.GetPackageName();
        if (this.addhide == true && this.edithide == false){
            this.GetSiteInfo();
        }
        this.GetCustomer();
        this.getServiceType();
        
    }

    ngAfterViewInit() {
        $("#Createddate").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $("#Renewaldate").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $("#CreatedDate1").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $("#RenewalDate1").datetimepicker({
            format: 'DD/MM/YYYY'
        });

        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

        setTimeout(() => {
            $('#teammultiselect').multiselect({
                enableFiltering: false,
                includeSelectAllOption: true,
                selectAllJustVisible: false,
            });

            $('#teammultiselect option').each(function () {
                if ($(this).attr('selected') == 'selected') {
                }
            });
        }, 1000);

        $("#teammultiselect").change(function () {
            var selectOption = $(this).find(":selected");
            var selectedValues = new Array();
            selectedOptionInUsersTab = new Array();
            selectOption.each(function (e) {
                selectedValues.push($(this).val());
                selectedOptionInUsersTab.push($(this).val());
            });
            $("#teammultiselect").val(selectedValues);
            $("#usersTeamAssigned").val(selectedValues);
            var selectPanel = $("#accordion").find(".panel.panel-default");
            selectPanel.each(function (e) {
                if (selectedOptionInUsersTab.includes($(this).find(".panel-collapse.collapse").attr("id"))) {
                    $(this).removeClass("hide");
                    $(this).addClass("show");
                }
                else {
                    $(this).removeClass("show");
                    $(this).addClass("hide");
                }
            });
        });
    }

    public selectedOptions() {
        return (this.options
            .filter(opt => opt.checked)
            .map(opt => opt.value).join());
    }

    public validateSelectedOptions() {
        if (this.options
            .filter(opt => opt.checked)
            .map(opt => opt.value).join() == '') {
            this.objSelectedOptions = false;
        }
        else {
            this.objSelectedOptions = true;
        }
    }

    public getServiceType() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["ServiceType"] }).subscribe(
            data => {
                this.serviceType = data["Parameter"];

            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getStatus() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["UserStatus"] }).subscribe(
            data => {
                this.siteInfoStatus = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public GetSiteInfo() {
        this.showLoader = true;
        this._httpService.ajaxPost('SiteInfo/GetSiteInfoByAccess', { "ServiceId": this.editSiteInfoId, "IsActive":"", "ServerType": 0, "CustomerId": 0, "RoleId" : this.userDetail.RoleId ,"loggedInUser" : this.userDetail.SiteUserId }).subscribe(
            data => {
                this.siteInfo = data["SiteInfoList"];
                this.EditSiteInfo(this.siteInfo);
                this.validateSelectedOptions();   

                 

                          
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public GetPackageName() {
        this.showLoader = true;
        this._httpService.ajaxPost('SiteInfo/GetSiteInfoByAccess', { "ServiceId": 0, "IsActive":"", "ServerType": 0, "CustomerId": 0, "RoleId" : this.userDetail.RoleId ,"loggedInUser" : this.userDetail.SiteUserId  }).subscribe(
            data => {
                this.siteInfoList = data["SiteInfoList"];
                this.siteInfoList.forEach(element => {
                    var isFound = false;
                    for (var i = 0; i < this.packageName.length; i++) {
                        if (this.packageName[i].Packagename == element.Packagename) {
                            isFound = true;
                            break;
                        }
                    }
                    if (!isFound) {
                        if (element.Packagename != "" && element.Packagename != null) {
                            this.packageName.push({ "Packagename": element.Packagename })
                        }
                    }
                });                
            },
            err => {
                this.showLoader = false;
                // this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public GetCustomer() {

        if(this.userDetail.RoleId==3){
                    this.isEditable=false;
                }else{
                    this.isEditable=true;
                }
        this.showLoader = true;
        this._httpService.ajaxPost('Customer/GetAssignedProjectCustomer', { "UserId" : this.userDetail.SiteUserId}).subscribe(
            data => {
                this.customerItem = data["CustomerList"];
                this.customerItem.sort();
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public clearFilter() {

        this.Search = "";
        this.filterSiteInfoStatus = this.constants.enumUserStatus["Active"];
        this.Customer_Name = "";
        this.filterServiceTypeStatus = "";
    }

    public CancelAddSiteInfo() {
        this.addSiteInfoData = { addSiteInfoClient: "", addSiteInfoServiceType: "", addSiteInfoOR: "", addSiteInfoIsActive: true };
        // this.newForm();
        this.existsServiceName = false;
        this.isAdd = true;
        setTimeout(() =>
            $('.customer').selectpicker({
                style: 'btn-info',
                size: 4
            })
            , 500);
        for (var i = 0; i < this.options.length; i++) {
            if(this.options[i].value!=1){
                this.options[i].checked = false;
            }
        }
    }

    public CancelEditSiteInfo() {
        this.existsServiceName = false;
        this.editSiteInfoData = {};
        this.newForm();
        $('#editSiteInfo').modal('hide');
        this.isAdd = true;
        this._Router.navigateByUrl('/siteInfo');
    }

    public AddSiteInfo(form: any) {
        this.isFormSubmitted = true;
        this.isDirty = true;
        if (form.form.valid && this.objSelectedOptions && this.greater == false) {
            this.existsServiceName = false;
            // this.siteInfoList.forEach(element => {
            //     if (element.ServiceName.trim().toLowerCase() == this.addSiteInfoData.addServiceName.trim().toLowerCase()) {
            //         this.existsServiceName = true;
            //     }
            // })
            if (!this.existsServiceName) {
                let objItem: any = {};
                objItem.ServiceId = 0;
                objItem.ServiceName = this.addSiteInfoData.addServiceName;
                objItem.CustomerId = this.addSiteInfoData.Customer_Id;
                objItem.ServerType = this.addSiteInfoData.addSiteInfoServiceType;
                objItem.Provider = this.addSiteInfoData.addProvider;
                objItem.URL = this.addSiteInfoData.addURL;
                objItem.Access = this.selectedOptions();
                if (
                    objItem.Packagename = this.addSiteInfoData.addPackageName) {
                    objItem.Packagename = this.addSiteInfoData.addPackageName;
                }
                else {
                    objItem.Packagename = this.addSiteInfoData.addSiteInfoOR;
                }
                objItem.CreateDate = this.addSiteInfoData.SiteInfoCreatedDate;
                objItem.RenewalDate = this.addSiteInfoData.SiteInfoRenewalDate;
                objItem.Remark = this.addSiteInfoData.addSiteInfoRemark;
                objItem.AppUser = this.addSiteInfoData.addSiteInfoAppUser;
                objItem.ControlPanel = this.addSiteInfoData.addSiteInfoControlPanel;
                objItem.SellingPrice = this.addSiteInfoData.addSellingPrice;
                objItem.CostPrice = this.addSiteInfoData.addCostPrice;
                objItem.IsActive = this.addSiteInfoData.addSiteInfoIsActive;
                objItem.CreatedBy = this.userDetail.SiteUserId;
                objItem.ModifiedBy = 0;
                this.addEditSiteInfo(objItem);
                // $('#addSiteInfo').modal('hide');
                // this.addSiteInfoData = {};
                // this.isAdd = true;
            }
        }
        else {
            if (this.greater) {
                this._sharedService.ShowMessage("warning|Renewal Date should be greater than Created Date");
            }
        }

    }

    public EditSiteInfo(item: any) {
        let objItem: any = item;
        this.editSiteInfoData.Customer_Id = objItem[0].CustomerId;
        this.editSiteInfoData.editServiceType = objItem[0].ServerType;
        this.editSiteInfoData.editServiceName = objItem[0].ServiceName;
        this.editSiteInfoData.editProvider = objItem[0].Provider;
        this.editSiteInfoData.editURL = objItem[0].URL;
        this.editSiteInfoData.editOR = objItem[0].Packagename;
        this.editSiteInfoData.editPackageName = objItem[0].Packagename;
        this.editSiteInfoData.editCreatedDate = objItem[0].CreateDate;
        this.editSiteInfoData.editRenewalDate = objItem[0].RenewalDate;
        this.editSiteInfoData.editRemark = objItem[0].Remark;
        this.editSiteInfoData.editAppUser = objItem[0].AppUser;
        this.editSiteInfoData.editControlPanel = objItem[0].ControlPanel;
        this.editSiteInfoData.editSellingPrice = objItem[0].SellingPrice;
        this.editSiteInfoData.editCostPrice = objItem[0].CostPrice;
        this.editSiteInfoData.editIsActive = objItem[0].IsActive;
        this.editSiteInfoData.option = objItem[0].Access;
        if (this.EditSiteInfo != null)
            if (item)
                var strArr = objItem[0].Access.split(',');
        for (var i = 0; i < this.options.length; i++) {
            var a = strArr.indexOf(this.options[i].value);

            if (a != -1) {
                this.options[i].checked = true;
            }
        }
    }

    public UpdateSiteInfo(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid && this.objSelectedOptions && this.greater == false) {
            this.existsServiceName = false;
            // this.siteInfoList.forEach(element => {
            //     if (element.ServiceId != this.editSiteInfoId && element.ServiceName.trim().toLowerCase() == this.editSiteInfoData.editServiceName.trim().toLowerCase()) {
            //         this.existsServiceName = true;
            //     }
            // })
            if (!this.existsServiceName) {
                let objItem: any = {};
                objItem.ServiceId = this.editSiteInfoId;
                objItem.ServiceName = this.editSiteInfoData.editServiceName;
                objItem.CustomerId = this.editSiteInfoData.Customer_Id;
                objItem.ServerType = this.editSiteInfoData.editServiceType;
                objItem.Provider = this.editSiteInfoData.editProvider;
                objItem.URL = this.editSiteInfoData.editURL;
                objItem.Packagename = this.editSiteInfoData.editOR;
                objItem.Access = this.selectedOptions();
                objItem.Createdate = this.editSiteInfoData.editCreatedDate;
                objItem.RenewalDate = this.editSiteInfoData.editRenewalDate;
                objItem.Remark = this.editSiteInfoData.editRemark;
                objItem.AppUser = this.editSiteInfoData.editAppUser;
                objItem.ControlPanel = this.editSiteInfoData.editControlPanel;
                objItem.SellingPrice = this.editSiteInfoData.editSellingPrice;
                objItem.CostPrice = this.editSiteInfoData.editCostPrice;
                objItem.IsActive = this.editSiteInfoData.editIsActive;
                objItem.CreatedBy = 0;
                objItem.ModifiedBy = this.userDetail.SiteUserId;
                this.addEditSiteInfo(objItem);
                //$('#editSiteInfo').modal('hide');
                // this.editSiteInfoData = {};
                // this.isAdd = true;
            }
        }
        else {
            if (this.greater) {
                this._sharedService.ShowMessage("warning|Renewal Date should be greater than Created Date");
            }
        }
    }

    addEditSiteInfo(objItem) {
        this.showLoader = true;
        this._httpService.ajaxPost('SiteInfo/AddUpdateSiteInfo', objItem).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    if(msg[0].toLowerCase() == 'warning' )
                    {
                        this.existsServiceName = true;
                    }
                    else
                    {
                        msg[0] = msg[0].toLowerCase();
                        this._Router.navigateByUrl('/siteInfo');
                        this._sharedService.ShowMessage(data["Status"].Message);
                         this.GetSiteInfo();
                       this.addSiteInfoData = {};
                       this.editSiteInfoData = {};
                       this.isAdd = true;
                    }
                }
                else {
                    
                    this._sharedService.ShowMessage(data["Status"].Message);
                     this.GetSiteInfo();
                }


               
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
    

    public OnGreater() {
        if (this.edithide) {
            var createdDate = moment(this.addSiteInfoData.SiteInfoCreatedDate, "DD/MM/YYYY");
            var renewalDate = moment(this.addSiteInfoData.SiteInfoRenewalDate, "DD/MM/YYYY");
            if (createdDate > renewalDate) {
                this._sharedService.ShowMessage("warning|Renewal Date should be greater than Created Date");
                this.greater = true;
            } else {
                this.greater = false;
            }
        } else {
            var createdDate = moment(this.editSiteInfoData.editCreatedDate, "DD/MM/YYYY");
            var renewalDate = moment(this.editSiteInfoData.editRenewalDate, "DD/MM/YYYY");
            if (createdDate > renewalDate) {
                this._sharedService.ShowMessage("warning|Renewal Date should be greater than Created Date");
                this.greater = true;
            } else {
                this.greater = false;
            }
        }
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/SiteInfo/SiteInfoList.component.ts
 **/